import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { isAuthenticated } from "services/Auth";
import { routes } from "routes";
import { showAuthModal } from "store/application/application-action";

export const LoginPage = (): JSX.Element => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    isAuthenticated().then((loggedIn: boolean) => {
      if (!loggedIn) {
        dispatch(showAuthModal());
      } else {
        navigate(routes.home());
      }
    });
  }, [navigate, dispatch]);

  return <></>;
};
